import React from 'react';
import PropTypes from 'prop-types';

const Collect = ({ width }) => {
  return (
    <svg
      className="logo"
      width={width}
      id="collect"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 366 169"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#f57767"
        d="M297 168.7c-54 0-85.9-36.7-85.9-84.9 0-51.7 36.7-82.3 84.3-82.3 42.5 0 70.6 22 70.6 51.7 0 28.1-24 46.3-51.1 46.3-14.7 0-25.6-2.9-32.9-8.6-2.9-2.2-4.5-1.9-4.5.6 0 10.5 3.8 19.5 10.9 26.5 5.7 5.7 16.6 9.6 26.8 9.6 10.5 0 19.8-2.2 28.1-6.4 8.3-4.1 15.3-2.9 19.5 3.8 4.8 7.7-1.9 17.5-7.7 23.9-10.8 11.5-31.3 19.8-58.1 19.8zM100.6 118.2c-5.1 0-8 2.9-11.5 8.3l-15.3 23.9c-5.7 9.3-10.5 15.6-21.7 15.6s-16.3-4.5-21.7-16.9c-6.7-15.3-13.7-33.8-20.1-58.7C3.2 62.7 0 45.5 0 31.4S4.5 9.1 19.8 6.2C40.9 2.4 69.3.1 100.6.1s59.7 2.2 80.8 6.1c15.3 2.9 19.8 11.2 19.8 25.2s-3.2 31.3-10.2 59c-6.4 24.9-13.4 43.4-20.1 58.7-5.4 12.4-10.5 16.9-21.7 16.9s-16-6.4-21.7-15.6l-15.3-23.9c-3.6-5.4-6.5-8.3-11.6-8.3z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#f5515c"
        d="M181.4 6.2c-3.1-.6-6.4-1.1-9.8-1.6-4.8 38.4 2.6 78.1 17.6 92.2.6-2.1 1.1-4.2 1.7-6.4 7-27.8 10.2-45 10.2-59 .1-14-4.4-22.3-19.7-25.2zM211.1 83.8c0 5.6.5 11.1 1.3 16.3 25.9-9.9 39.1-50.7 72.5-80.6 8.3-7.5 16.8-13 25.2-17.1-4.7-.6-9.6-.9-14.7-.9-47.6 0-84.3 30.6-84.3 82.3z"
      />
      <path
        d="M112.1 126.5l15.3 23.9c5.7 9.3 10.5 15.6 21.7 15.6 6.1 0 10.5-1.4 14-4.6-43.6-75.3-57.2-122.2-97.9-106.8-25.5 9.7-37.9 41.9-38.5 86 1.2 2.9 2.4 5.8 3.6 8.5C35.7 161.5 40.8 166 52 166s16-6.4 21.7-15.6L89 126.5c3.5-5.4 6.4-8.3 11.5-8.3 5.2 0 8.1 2.9 11.6 8.3z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#f75c2d"
      />
    </svg>
  );
};

Collect.propTypes = {
  width: PropTypes.number,
};

Collect.defaultProps = {
  width: 24,
};

export default Collect;
